angular
	.module 'App.Component'
	.component 'qrCodeModal',
		{
			templateUrl: '@component/qr-code/modals/qr-code.modal.view.html'
			controller: 'QrCodeModalController'
			controllerAs: 'qrCodeModal'
			bindings:
				resolve: '<'
				close: '&'
				dismiss: '&'
		}

class QrCodeModalController extends AbstractController
	@register()
	@inject '$element', 'Guid'

	initialize: ->
		@url = @resolve.url
		@alt = @resolve.alt ? @resolve.title
		@title = @resolve.title
